import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../../store";
import { getUserById, updateUser, changePassword } from "../modules/actions";
import {
  getInsuranceById,
  getInsurances,
} from "../../Insurance/modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    currentUser: state.usersReducer.currentUser,
    currentInsurance: state.insuranceReducer.insuranceToEdit,
    insurances: state.insuranceReducer.insurances,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      getUserById,
      updateUser,
      changePassword,
      getInsuranceById,
      getInsurances,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
